export enum StorageType {
    Box = 0,
    Blob = 1,
}

export const StorageTypes = Object.values(StorageType).filter(v => !isNaN(v as StorageType)) as StorageType[];
